import { render, staticRenderFns } from "./listado-tareas.vue?vue&type=template&id=0568752b&scoped=true"
import script from "./listado-tareas.vue?vue&type=script&lang=js"
export * from "./listado-tareas.vue?vue&type=script&lang=js"
import style0 from "./listado-tareas.vue?vue&type=style&index=0&id=0568752b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568752b",
  null
  
)

export default component.exports